import axios from "axios";
import {
  AddressCard,
  AlertFilledIcon,
  Button,
  CartItem,
  CartToolbar,
  EditIcon,
  Message,
  Modal,
  PageHeader,
  Spinner,
  TextArea,
} from "dab-component-lib";
import _ from "lodash";
import React from "react";
import { compose, graphql } from "react-apollo";
import { withRouter } from "react-router";
import I18n from "../../I18n/I18n";
import {
  currencyById,
  currentUserCart,
  currentUserQuery,
  getText,
} from "../../queries";
import { GETBASKETS, PERFORM_ORDER } from "../../utils/constants";

import {
  ErrorStyle,
  GridContainerStyle,
  LoadingStyle,
  PageHeaderWrapperStyle,
} from "../../utils/style-utils";
import {
  ActionsRowStyle,
  BackStyleHeader,
  BasketBaseStyle,
  BasketNameStyle,
  ButtonWrapperStyle,
  CartItemWrapper,
  OrderColStyle,
  OrderNotesStyle,
  OrderNotesWrapperStyle,
  OrderRowStyle,
} from "./style";

class BudgetError extends Error {}

class OrderSummary extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      orderResult: "",
      orderNotes: "",
      orderNotesOpen: false,
      badBudget: false,
      badOrder: false,
      badQuantity: false,
      goodOrder: false,
      amountAlert: false,
      showNotes: false,
      loading: false,
    };
  }

  afterOrder = async (res) => {
    const { currentUserCart, currentUserQuery, location } = this.props;
    const { selectedCategory } = location.state;
    await currentUserCart.refetch({
      id: localStorage.getItem("currentUid"),
    });
    await currentUserQuery.refetch();
    this.setState({ loading: false });
    if (res instanceof BudgetError) {
      await this.setState({ badBudget: true });
    } else if (res instanceof Error) {
      await this.setState({ badOrder: true });
    } else {
      if (res.data.status === 0) {
        await this.setState({ badOrder: true });
      } else if (res.data.status === -1) {
        await this.setState({ badQuantity: true });
      } else {
        await this.setState({ goodOrder: true });
        if (res.data["0"].amount <= 0 && selectedCategory !== "SALES") {
          await this.setState({ amountAlert: true });
        }
      }
    }
    this.setState({ showModalOrder: true });
  };

  sendOrder = async () => {
    this.setState({ loading: true });
    const {
      selectedAddress = {},
      selectedBasket,
      selectedCategory,
      selectedLocation,
    } = this.props.location.state;
    const { orderNotes } = this.state;
    const { currentUserCart, currentUserQuery } = this.props;
    if (
      !currentUserCart.loading &&
      !currentUserCart.error &&
      !currentUserQuery.loading &&
      !currentUserQuery.error
    ) {
      let cart_id = currentUserCart.currentusercartGraphql1View.results[0].id;
      let customer_id = selectedAddress && selectedAddress.business_id;
      let address_id = selectedAddress && selectedAddress.code;
      let isBuyerAgent = _.find(
        currentUserQuery.currentUserContext.roles,
        (role) => role.targetId === "buyer_agent"
      );
      let homage = selectedCategory
        ? selectedCategory
        : isBuyerAgent
        ? "HOMAGE"
        : "empty";
      let zone = selectedLocation ? selectedLocation : "empty";
      const send_mail = false;
      let uid = localStorage.getItem("currentUid");

      let baskets = await axios.get(`${GETBASKETS}/${uid}`);
      let basket =
        !!selectedBasket && selectedBasket !== "area_manager_italia"
          ? _.find(
              baskets.data,
              (basket) => basket[1].basket_type === selectedBasket
            )
          : baskets.data[0];
      if (
        basket === undefined ||
        basket === null ||
        baskets.data.length === 0
      ) {
        throw new BudgetError("Budget non trovato");
      }

      let basket_id = basket[0].id;
      if (basket_id === undefined || basket_id === null) {
        throw new BudgetError("Budget non valido");
      }
      axios({
        url: `${PERFORM_ORDER}/${basket_id}/${customer_id}/${address_id}/${cart_id}/${homage}/${zone}/${send_mail}/${uid}`,
        headers: {
          "Content-Type": "application/x-www-form-urlencoded",
        },
        method: "POST",
        credentials: "include",
        data: orderNotes,
      })
        .then((res) => this.afterOrder(res))
        .catch((err) => this.afterOrder(err));
      
    }
  };

  closeModal = async (value) => {
    const { history } = this.props;
    await this.setState({ showModalOrder: false });
    if (value) {
      history.push(value);
    }
  };

  orderTypeChosen = (basket, type, location) => {
    if (type) {
      type = type.toLowerCase().trim();
    }

    switch (basket) {
      case "d_training":
        return (
          <BasketBaseStyle>
            <BasketNameStyle>
              {I18n.t("content.order")} DTraining
            </BasketNameStyle>
            <BasketNameStyle>
              {type &&
                (type === "homage"
                  ? `${I18n.t("content.order")} ${I18n.t("content.homage")}`
                  : `${I18n.t("content.order")} ${I18n.t("content.sale")}`)}
            </BasketNameStyle>
            <BasketNameStyle>
              {location && `${I18n.t("content.order")} ${location}`}
            </BasketNameStyle>
          </BasketBaseStyle>
        );
      case "business_area_budget":
        return (
          <BasketBaseStyle>
            <BasketNameStyle>
              {I18n.t("content.order")} Area Export
            </BasketNameStyle>
            <BasketNameStyle>
              {type &&
                (type === "homage"
                  ? `${I18n.t("content.order")} ${I18n.t("content.homage")}`
                  : `${I18n.t("content.order")} ${I18n.t("content.sale")}`)}
            </BasketNameStyle>
            <BasketNameStyle>
              {location && `${I18n.t("content.order")} ${location}`}
            </BasketNameStyle>
          </BasketBaseStyle>
        );
      case "admin_budget":
        return (
          <BasketBaseStyle>
            <BasketNameStyle>{I18n.t("content.order")} DAB</BasketNameStyle>
            <BasketNameStyle>
              {type &&
                (type === "homage"
                  ? `${I18n.t("content.order")} ${I18n.t("content.homage")}`
                  : `${I18n.t("content.order")} ${I18n.t("content.sale")}`)}
            </BasketNameStyle>
            <BasketNameStyle>
              {location && `${I18n.t("content.order")} ${location}`}
            </BasketNameStyle>
          </BasketBaseStyle>
        );
      default:
        return;
    }
  };

  render() {
    const {
      selectedAddress,
      selectedBasket,
      selectedCategory,
      selectedLocation,
    } = this.props.location.state;
    const {
      orderNotes,
      orderNotesOpen,
      showModalOrder,
      badOrder,
      badBudget,
      badQuantity,
      amountAlert,
      showNotes,
    } = this.state;
    const {
      history,
      currentUserCart: { loading, error, currentusercartGraphql1View },
      currencyById,
      getText,
      getTextModal1,
      getTextModal2,
      getTextModal3,
      getTextModal4,
      currentUserQuery,
    } = this.props;

    let sumPrices = 0;
    let currencySign = null;

    if (
      loading ||
      currencyById.loading ||
      this.state.loading ||
      getText.loading ||
      getTextModal1.loading ||
      getTextModal2.loading ||
      getTextModal3.loading ||
      getTextModal4.loading ||
      currentUserQuery.loading
    ) {
      return (
        <LoadingStyle>
          <Spinner size={150} />
        </LoadingStyle>
      );
    }
    if (
      error ||
      currencyById.error ||
      getText.error ||
      getTextModal1.error ||
      getTextModal2.error ||
      getTextModal3.error ||
      getTextModal4.error ||
      currentUserQuery.error
    ) {
      return (
        <ErrorStyle>
          <Message title={I18n.t("errors.cartError")} />
        </ErrorStyle>
      );
    }

    return (
      <GridContainerStyle>
        {badOrder || badBudget || badQuantity ? (
          <Modal open={showModalOrder} handleClose={() => this.closeModal()}>
            <div>
              {badOrder ? (
                <Message
                  title={
                    getTextModal1.translationMetadataGraphql1View.results
                      .length > 0 &&
                    getTextModal1.translationMetadataGraphql1View.results[0]
                      .fieldMainText
                  }
                  description={
                    getTextModal1.translationMetadataGraphql1View.results
                      .length > 0 &&
                    getTextModal1.translationMetadataGraphql1View.results[0]
                      .fieldSubText
                  }
                />
              ) : badQuantity ? (
                <Message
                  title={
                    getTextModal4.translationMetadataGraphql1View.results
                      .length > 0 &&
                    getTextModal4.translationMetadataGraphql1View.results[0]
                      .fieldMainText
                  }
                  description={
                    getTextModal4.translationMetadataGraphql1View.results
                      .length > 0 &&
                    getTextModal4.translationMetadataGraphql1View.results[0]
                      .fieldSubText
                  }
                />
              ) : (
                <Message
                  title={I18n.t("modals.errorBudgetTitle")}
                  description={I18n.t("modals.errorBudgetDescription")}
                />
              )}
            </div>
          </Modal>
        ) : (
          <Modal open={showModalOrder}>
            <div>
              <Message
                action={{
                  label: I18n.t("buttons.visitAfterOrder"),
                  onClick: () => this.closeModal("/"),
                }}
                actionSecondary={{
                  label: I18n.t("buttons.goOrders"),
                  onClick: () => this.closeModal("/user-orders"),
                }}
                title={
                  getTextModal2.translationMetadataGraphql1View.results.length >
                    0 &&
                  getTextModal2.translationMetadataGraphql1View.results[0]
                    .fieldMainText
                }
                description={
                  getTextModal2.translationMetadataGraphql1View.results.length >
                    0 &&
                  getTextModal2.translationMetadataGraphql1View.results[0]
                    .fieldSubText
                }
              />
              {amountAlert && (
                <div>
                  <AlertFilledIcon
                    color="#ff0000"
                    orientation="top"
                    size={40}
                  />
                  {getTextModal3.translationMetadataGraphql1View.results
                    .length > 0 &&
                    getTextModal3.translationMetadataGraphql1View.results[0]
                      .fieldSubText}
                </div>
              )}
            </div>
          </Modal>
        )}
        <BackStyleHeader onClick={() => history.goBack()}>
          {"< Indietro"}
        </BackStyleHeader>
        <PageHeaderWrapperStyle bigger>
          <PageHeader
            title={
              getText.translationMetadataGraphql1View.results.length > 0 &&
              getText.translationMetadataGraphql1View.results[0].fieldMainText
            }
            description={
              getText.translationMetadataGraphql1View.results.length > 0 &&
              getText.translationMetadataGraphql1View.results[0].fieldSubText
            }
          />
        </PageHeaderWrapperStyle>
        <OrderRowStyle>
          <OrderColStyle>
            <div>
              {currentusercartGraphql1View.results[0].fieldLineItemsReference.map(
                (item) => {
                  let product = item.entity.fieldProductReference.entity;
                  let quantity = item.entity.fieldProductReference.quantity;
                  let price = {};
                  if (!currencyById.error && !currencyById.loading) {
                    let currencyName = currencyById.nodeById.fieldCurrencyName;
                    currencySign = currencyById.nodeById.fieldCurrencySign;
                    price = _.find(
                      product.fieldPrices,
                      (price) =>
                        price.entity.fieldCurrency ===
                        (currencyName ? currencyName : "EUR")
                    );
                  }
                  sumPrices += price.entity.fieldPriceAmount * quantity;
                  return (
                    <CartItemWrapper key={item.targetId}>
                      <CartItem
                        currency={currencySign}
                        editable={false}
                        id={item.targetId.toString()}
                        lang={
                          localStorage.getItem("language")
                            ? localStorage.getItem("language")
                            : "it"
                        }
                        maxQuantity={product.fieldMaxShopQuantity}
                        name={product.name}
                        note={item.entity.fieldLineItemNotes}
                        photoUrl={
                          product.fieldProductImages.length > 0
                            ? product.fieldProductImages[0].url
                            : ""
                        }
                        price={parseFloat(
                          price.entity.fieldPriceAmount * quantity
                        ).toFixed(2)}
                        productId={product.fieldCode}
                        quantity={quantity}
                        size=""
                      />
                    </CartItemWrapper>
                  );
                }
              )}
            </div>
            <CartToolbar
              lang={
                localStorage.getItem("language")
                  ? localStorage.getItem("language")
                  : "it"
              }
              currency={currencySign}
              totalItems={
                currentusercartGraphql1View.results.length > 0
                  ? currentusercartGraphql1View.results[0]
                      .fieldLineItemsReference.length
                  : 0
              }
              totalPrice={sumPrices.toFixed(2)}
            />
          </OrderColStyle>
          <OrderColStyle third>
            {this.orderTypeChosen(
              selectedBasket,
              selectedCategory,
              selectedLocation
            )}
            <AddressCard
              country={selectedAddress && selectedAddress.country_description}
              email={selectedAddress && selectedAddress.email}
              iconSize="S"
              name={selectedAddress && selectedAddress.name}
              phone={selectedAddress && selectedAddress.telephone}
              place={selectedAddress && selectedAddress.place}
              street={selectedAddress && selectedAddress.street}
              zipCode={selectedAddress && selectedAddress.zipCode}
            />
            <div>
              <OrderNotesStyle
                onClick={() =>
                  this.setState({
                    orderNotesOpen: !this.state.orderNotesOpen,
                    showNotes: false,
                  })
                }
              >
                <EditIcon color="#004615" orientation="top" size={24} />
                <span>
                  {orderNotes === ""
                    ? I18n.t("content.orderNotes")
                    : I18n.t("content.editOrderNotes")}
                </span>
              </OrderNotesStyle>
              <OrderNotesWrapperStyle>
                {orderNotesOpen && (
                  <div>
                    <div>
                      <TextArea
                        id="order-notes"
                        name={I18n.t("content.orderNotes")}
                        onBlur={function noRefCheck() {}}
                        onChange={(event) =>
                          this.setState({ orderNotes: event.target.value })
                        }
                        onFocus={function noRefCheck() {}}
                        placeholder={I18n.t("content.addOrderNotes")}
                        rows={10}
                        value={orderNotes}
                      />
                    </div>
                    <ButtonWrapperStyle>
                      <Button
                        icon={null}
                        iconOrientation="top"
                        id="save-order-note"
                        label={I18n.t("content.saveOrderNotes")}
                        onClick={() =>
                          this.setState({
                            orderNotesOpen: !this.state.orderNotesOpen,
                            showNotes: true,
                          })
                        }
                        onMouseEnter={function noRefCheck() {}}
                        onMouseLeave={function noRefCheck() {}}
                        size="S"
                      />
                    </ButtonWrapperStyle>
                  </div>
                )}
                {showNotes && <div>{orderNotes}</div>}
              </OrderNotesWrapperStyle>
            </div>
          </OrderColStyle>
        </OrderRowStyle>
        <ActionsRowStyle>
          <div />
          <Button
            icon={null}
            iconOrientation="top"
            id="order"
            label={I18n.t("buttons.sendOrder")}
            onClick={() => this.sendOrder()}
            onMouseEnter={function noRefCheck() {}}
            onMouseLeave={function noRefCheck() {}}
            size="M"
          />
        </ActionsRowStyle>
      </GridContainerStyle>
    );
  }
}

export default compose(
  graphql(currentUserQuery, {
    name: "currentUserQuery",
  }),
  graphql(currentUserCart, {
    name: "currentUserCart",
    options: () => ({
      variables: {
        id: localStorage.getItem("currentUid"),
        lang: localStorage.getItem("language")
          ? localStorage.getItem("language")
          : "it",
      },
    }),
  }),
  graphql(currencyById, {
    name: "currencyById",
    options: () => ({
      variables: {
        id: localStorage.getItem("currency")
          ? localStorage.getItem("currency")
          : localStorage.getItem("defaultCurrency"),
      },
    }),
  }),
  graphql(getText, {
    name: "getText",
    options: () => ({
      variables: {
        machineName: "order_summary",
        lang: localStorage.getItem("language")
          ? localStorage.getItem("language")
          : "it",
      },
    }),
  }),
  graphql(getText, {
    name: "getTextModal1",
    options: () => ({
      variables: {
        machineName: "order_summary_bad_order",
        lang: localStorage.getItem("language")
          ? localStorage.getItem("language")
          : "it",
      },
    }),
  }),
  graphql(getText, {
    name: "getTextModal2",
    options: () => ({
      variables: {
        machineName: "order_summary_good_order",
        lang: localStorage.getItem("language")
          ? localStorage.getItem("language")
          : "it",
      },
    }),
  }),
  graphql(getText, {
    name: "getTextModal3",
    options: () => ({
      variables: {
        machineName: "order_summary_end_budget",
        lang: localStorage.getItem("language")
          ? localStorage.getItem("language")
          : "it",
      },
    }),
  }),
  graphql(getText, {
    name: "getTextModal4",
    options: () => ({
      variables: {
        machineName: "order_summary_bad_quantity",
        lang: localStorage.getItem("language")
          ? localStorage.getItem("language")
          : "it",
      },
    }),
  })
)(withRouter(OrderSummary));



// WEBPACK FOOTER //
// ./src/components/orderSummary/index.js